var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E233E",
    fillRule: "nonzero",
    stroke: "#1E233E",
    d: "M13.512 1H3.41C2.19 1 1.2 1.99 1.2 3.21v22.098c0 1.22.99 2.21 2.21 2.21h10.102c1.22 0 2.21-.99 2.21-2.21V3.21c0-1.22-.99-2.21-2.21-2.21zm.947 24.308a.947.947 0 0 1-.947.947H3.41a.947.947 0 0 1-.947-.947V3.21c0-.523.424-.947.947-.947h1.578c.175 0 .316.141.316.315 0 .524.424.948.947.948h4.42a.947.947 0 0 0 .947-.948c0-.174.141-.315.315-.315h1.579c.523 0 .947.424.947.947v22.098z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobile-phone.460615228f77e050b9f19e4df3f582d1.svg";
export { ForwardRef as ReactComponent };